import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IVendorSettings } from './vendor/vendor-settings-types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class VendorSettingsService {

  constructor(private http: HttpClient) { }

  readonly getVendorSettingsUrl = '/vendor/getSettings';
  readonly saveVendorSettingsUrl = '/vendor/save_settings_data.json';
  
  getSettings() {
    return this.http.get<IVendorSettings>(this.getVendorSettingsUrl);
  }

  saveSettings(settings: IVendorSettings): Observable<string> {
    return this.http.post<string>(this.saveVendorSettingsUrl, settings);
  }
}

let vendorSettingsServiceStub: Partial<VendorSettingsService> = {};
export { vendorSettingsServiceStub };